import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { Box, Button, Typography } from "@mui/material";
import { Link } from "react-router-dom";

export const UnauthorizedPage = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        gap: 2,
        py: 10,
        px: 2,
      }}
    >
      <LockOutlinedIcon color="error" sx={{ fontSize: 64 }} />
      <Typography variant="h5" fontWeight={600}>
        Unauthorized
      </Typography>
      <Typography variant="body1" color="text.secondary" maxWidth={420}>
        You don't have permission to view this page. If you think this is a mistake, please contact your administrator.
      </Typography>
      <Button variant="contained" component={Link} to="/app/dashboard">
        Go to Dashboard
      </Button>
    </Box>
  );
};
